module.exports = __webpack_public_path__ + "img/step-four.90bc4488.png";